 import { routes as dashoardRoutes } from "./Tabs/routes"; 
export const routes = (prefix=`home`) => [
    {
        name: `${prefix}.home-dashboard.index`,
        path: `/${prefix}/home-dashboard`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.home-dashboard.index`,
                PageDescription: "Home - Main DashBoard",
            },
        },
    },
     ...dashoardRoutes(prefix), 
];
